import { Component, Input } from '@angular/core';

import { SignedVacations } from '@app/mot/schedule/shared/model/signed-vacations';
import { FeedbackTypes } from '@app/ptrab/shared/enums/feedback.enum';

@Component({
  selector: 'app-signed-vacations',
  templateUrl: './signed-vacations.component.html',
  styleUrls: ['./signed-vacations.component.scss']
})
export class SignedVacationsComponent {
  @Input() signedVacations: SignedVacations[] = [];
  feedbackTypes = FeedbackTypes;
}
